import { ClipLoader } from "react-spinners";
import React from "react";

interface Props {
  size?: number;
  color?: string;
}

// The theme's muted text colour shows on both light and dark backgrounds
export const Loader = ({ size = 20, color = "var(--dt-muted)" }: Props) => {
  return (
    <ClipLoader
      color={color}
      cssOverride={{
        margin: "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      size={size}
      aria-label="Loading Spinner"
      data-testid="loader"
    />
  );
};
